import { Injectable } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { environment } from '../../environments/environment';

@Injectable()
export class AutocompleteService {
    #places: any;
    #autocomplete: any;

    get autocomplete() {
        return this.#autocomplete;
    }

    set autocomplete(ac: any) {
        this.#autocomplete = ac;
    }

    constructor() {
    }

    async loadScript() {
        const loader = new Loader({
            apiKey: environment.googleApiKey,
            version: 'weekly'
        });

        await loader.load();
        this.#places = await google.maps.importLibrary('places');
        this.autocomplete = new this.#places.AutocompleteService();
    }

    getPropertyAutocomplete(el: HTMLInputElement) {
        return new this.#places.Autocomplete(el, { types: ['address'] });
    }
}
